<template>
    <div>
        <Modal v-model="autoReturn.show" title="自送归还确认" width="800px" @on-ok="submint" @on-cancel="cancels" :loading="loading">
            <Form :model="formData" ref="formValidates" :label-width="110" inline :rules="ruleValFinis">
                <FormItem label="归还预约单号">
                    <Input v-model="autoReturn.data.id" disabled style="width: 180px" />
                </FormItem>
                <FormItem label="租借人">
                    <Input v-model="autoReturn.leaseeId" disabled style="width: 180px" />
                </FormItem>
                <br />
                <FormItem label="仓库编号">
                    <Input v-model="autoReturn.data.storageId" disabled style="width: 180px" />
                </FormItem>
                <FormItem label="标的物小类">
                    <Input v-model="autoReturn.targetType" disabled style="width: 180px" />
                </FormItem>
                <br />
                <FormItem label="预约归还数量">
                    <InputNumber disabled v-model="autoReturn.data.totalAmount" style="width:180px"></InputNumber>
                </FormItem>
                <FormItem label="归还数量" prop="amount">
                    <InputNumber :min="1" :max="autoReturn.data.totalAmount" v-model="formData.amount" style="width:180px"></InputNumber>
                </FormItem>
                <br />
                <FormItem label="归还时间" prop="recycledTime">
                    <DatePicker @on-change="onRecycledTime" type="date" :editable="false" v-model="formData.recycledTime" placeholder="请输入归还时间" style="width: 180px"></DatePicker>
                </FormItem>
                <br />
                <FormItem label="备注">
                    <Input v-model="formData.selfDeliverAckComment" type="textarea" style="width:490px" />
                </FormItem>
                <br />
                <FormItem label="上传附件">
                    <upload ref="upFiles" :height="70" :width="489" :format="[]" title="上传附件" @success="uploadSuccess" @delete="onDelete"></upload>
                </FormItem>
            </Form>
        </Modal>
    </div>
</template>

<script>
import upload from '@/components/upload/upload';

export default {
    components: { upload },
    props: {
        autoReturn: Object
    },
    data() {
        return {
            loading: true,
            attachmentFileIds: [],
            formData: {
                id: '',
                leaseeId: '',
                storageId: "",
                targetType: '',
                amount: null,//归还数量
                recycledTime: '',
                selfDeliverAckComment:"",//备注

            },
            ruleValFinis: {
                amount: [{ required: true, message: "归还数量不能为空！" }],
                recycledTime: [{ required: true, message: '请选择收款时间！', trigger: 'change' }],
            },
        }
    },
    methods: {
        onRecycledTime(val) {
            this.formData.recycledTime = val
        },
        // 上传附件回调
        uploadSuccess(params) {
            this.attachmentFileIds.push(params.body)
        },
        // 上传附件删除回调
        onDelete({id}) {
            this.attachmentFileIds = this.attachmentFileIds.filter(item => item != id);

        },
        submint() {
            this.$refs['formValidates'].validate((valid) => {
                if (valid) {
                    let data = {
                        url: 'MID-OPERATE-LEASE/messageService/recycleService/selfDeliveryConfirm',
                        body: {
                            amount: this.formData.amount,
                            leaseeId: this.autoReturn.data.leaseeId,
                            recycleAppointmentId: this.autoReturn.data.id,
                            recycledTime: this.formData.recycledTime,
                            storageId: this.autoReturn.data.storageId,
                            targetType: this.autoReturn.data.targetType,
                            attachmentFileIds: this.attachmentFileIds,
                            selfDeliverAckComment:this.formData.selfDeliverAckComment
                        }
                    }
                    this.invoke(data).then(res => {
                        if (!res) {
                            this.$Message.success("自送归还成功！")
                            setTimeout(() => {
                                this.cancels()
                                this.$emit('serch')
                            }, 1400)

                        }

                    }).catch(err => {
                        this.loading = false
                        setTimeout(() => {
                            this.loading = true
                        }, 10)

                    })

                } else {
                    this.loading = false
                    setTimeout(() => {
                        this.loading = true
                    }, 10)
                }
            })

        },
        cancels() {
            this.$refs['formValidates'].resetFields()
            this.autoReturn.show = false
            this.$refs.upFiles.$refs.uploadFile.clearFiles()
            this.attachmentFileIds = []
            this.formData.selfDeliverAckComment = ""

        },

    }

}
</script>